import { createLocalizationContext, ELanguage } from '@smartshell/ui-kit';

import type ru from './locales/ru.json';

export { initializeLanguagePreference } from './languagePreference';
export { getLanguageTitle, LANGUAGE_OPTIONS } from './languages';

export const LocalizationContext = createLocalizationContext<TLocalesKeys>();

export type TLocalesKeys = keyof typeof ru;

export const LOCALES_MAP: Record<
  ELanguage,
  () => Promise<Record<TLocalesKeys, string>>
> = {
  [ELanguage.EN]: () => {
    import('dayjs/locale/en');
    return import('./locales/en.json');
  },
  [ELanguage.RU]: () => {
    import('dayjs/locale/ru');
    return import('./locales/ru.json');
  },
  [ELanguage.VI]: () => {
    import('dayjs/locale/vi');
    return import('./locales/vi.json');
  },
  [ELanguage.ES]: () => {
    import('dayjs/locale/es');
    return import('./locales/es.json');
  },
  [ELanguage.KK]: () => {
    import('dayjs/locale/kk');
    return import('./locales/kk.json');
  },
  [ELanguage.UZ]: () => {
    import('dayjs/locale/uz-latn');
    return import('./locales/uz.json');
  },
  [ELanguage.KY]: () => {
    import('dayjs/locale/ky');
    return import('./locales/ky.json');
  },
  [ELanguage.AZ]: () => {
    import('dayjs/locale/az');
    return import('./locales/az.json');
  },
  [ELanguage.PT]: () => {
    import('dayjs/locale/pt-br');
    return import('./locales/pt.json');
  },
  [ELanguage.FR]: () => {
    import('dayjs/locale/fr');
    return import('./locales/fr.json');
  },
  [ELanguage.TR]: () => {
    import('dayjs/locale/tr');
    return import('./locales/tr.json');
  },
  [ELanguage.DE]: () => {
    import('dayjs/locale/de');
    return import('./locales/de.json');
  },
};
